import { Button } from '@mui/material'
import { useState } from 'react'
import { getAssetUrl } from '../config'
import type { SiteInfo } from '../hooks'
import LoginDialog from '../LoginRedirector/LoginDialog'
import styles from './HomePage.module.css'

interface HomePageProps {
  onLoginSuccess: (sites: SiteInfo[]) => void
}

export default function HomePage({ onLoginSuccess }: HomePageProps) {
  const [showLoginDialog, setShowLoginDialog] = useState(false)

  const handleLoginClick = () => {
    setShowLoginDialog(true)
  }

  const handleLoginSuccess = (sites: SiteInfo[]) => {
    setShowLoginDialog(false)
    onLoginSuccess(sites)
  }

  const handleCloseDialog = () => {
    setShowLoginDialog(false)
  }

  return (
    <>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.banner}>
            <img src={getAssetUrl('/logo.svg')} alt="Logo" className={styles.logo} />
            <h1 className={styles.siteName} data-testid="site-name">
              几点几体育
            </h1>
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLoginClick}
            className={styles.loginButton}
            data-testid="login-button"
          >
            登录
          </Button>
        </header>

        <main className={styles.main}>
          <section className={styles.intro}>
            <h2 className={styles.title}>"网球几点几" APP 介绍</h2>
            <p className={styles.description}>
              "网球几点几"APP是专为网球爱好者打造的水平评估 + 以球会友 +
              赛事管理的一体化工具
            </p>
          </section>

          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>精准水平评级：科学定义你的网球实力</h3>
            <p className={styles.sectionText}>
              通过记录用户真实对战数据（如回合数、得分效率等），结合行业通用的 1.0-7.0
              评级标准，科学评估网球水平，让实力可视化。助力用户明确提升方向，也为约球、参赛提供实力参考。
            </p>
          </section>

          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>同频约球互动：轻松找到匹配球友</h3>
            <p className={styles.sectionText}>
              支持按水平等级（如 2.5
              级、3.5级）筛选附近友谊赛，或自主发起约球，轻松实现'随时约、同水平打"。既能通过同水平对抗提升球技，又能结识兴趣相投的球友，兼顾运动与社交。
            </p>
          </section>

          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>俱乐部赛事管理：提升运营效率</h3>
            <p className={styles.sectionText}>
              俱乐部可一键发起赛事、自动生成赛程表、同步通知参赛用户，减少人工统计成本，提升赛事组织效率。让俱乐部赛事组织更高效，也让会员参赛流程更便捷，提升俱乐部活跃度。
            </p>
          </section>
        </main>
      </div>

      {showLoginDialog && (
        <LoginDialog onLoginSuccess={handleLoginSuccess} onClose={handleCloseDialog} />
      )}
    </>
  )
}
